import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { LanControllerInfo } from "../GQLCalls/getLanControllersCall";
import { LanControllerRegister } from "../GQLCalls/getLanControllerRegistersCall";


export type LanControllerItem = DynamicDataObk<LanControllerInfo[]> & { cpuOptions?: LanControllerRegister[] }

const lanControllerDataAdapter = createEntityAdapter({
  selectId: (item: LanControllerItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<LanControllerItem, string>, {con, data, cpuOptions}: LanControllerItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "controller_id")
    data.forEach((entry) => dataDictionary[entry.controller_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary), cpuOptions: Object.values(merge({}, keyBy(state.entities[identifier].cpuOptions, "lan_controller_id"), keyBy(cpuOptions, "lan_controller_id")))}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) || cpuOptions?.length  ) {
      lanControllerDataAdapter.upsertOne(state, newPayload);
    }
  } else { lanControllerDataAdapter.addOne(state, {con, data, cpuOptions: cpuOptions ?? [] })}
}

const lanControllerSlice = createSlice({
  name: "lanControllers",
  initialState: lanControllerDataAdapter.getInitialState(),
  reducers: {
    maintained: (state, {payload}:PayloadAction<LanControllerItem>) => {
      mergePayloadAndState(state, payload);
    }
  }
})

export const LanControllerActions = lanControllerSlice.actions;
export default lanControllerSlice.reducer;